module.exports = __webpack_public_path__ + "static/media/FriedOne.ca887a5a.png";